import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AddEditCouponCodeComponent } from './addEditCouponCode.component';

import { CouponCodeModel } from '../../../model/couponCode.model';
import { CouponCodeService } from '../../../services/couponCode.service';

@Component({
    selector: 'couponCode-tab',
    templateUrl: './couponCode.component.html',
})
export class CouponCodeMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public couponCodedata: any[] = [];

    isLoadMask: Promise<any>;
    couponCodeData: CouponCodeModel[];
    isLoading: boolean = false;

    constructor(private couponCodeService: CouponCodeService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 60, minWidth: 60, maxWidth: 60, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Campaign Name', prop: 'campaign_name', width: 180, minWidth: 180 },
            { name: 'Coupon Code', prop: 'coupon_code', width: 160, minWidth: 160, maxWidth: 160 },
            { name: 'Type', prop: 'discount_type', width: 110, minWidth: 110, maxWidth: 110 },
            { name: 'Disc. Amount', prop: 'discount_amount', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Disc. %', prop: 'discount_percentage', width: 110, minWidth: 110, maxWidth: 110 },
            { name: 'Start Date', prop: 'disp_start_date', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'End Date', prop: 'disp_end_date', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Total Count', prop: 'total_count', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Status', prop: 'status', width: 90, minWidth: 90, maxWidth: 90 },
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getCouponCodeList();
        }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) { }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100);
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getCouponCodeList();
    }

    getCouponCodeList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.couponCodeService
            .getCouponCodeList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.couponCodeData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditCouponCode(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditCouponCodeComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Coupon Code';
        this.bsModalRef.content.couponCodedata = Object.assign({}, row);
        this.bsModalRef.content.couponCodeLoadEvent.subscribe(($e) => {
            that.getCouponCodeList();
        });
    }

    onDeleteCouponCode(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Coupon Code entry Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.couponCodeService
                .deleteCouponCode(row.id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getCouponCodeList();
                        swal('Deleted', res.message, 'success');
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                });
        }, function(dismiss) { });
    }
}


// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/couponCode/couponCode.component.ts